import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import {
  TabSettings,
  FormattedCell,
  ReportSettings
} from '../../models/report';
import { getColumnSettings, valueToCell } from './excel.formatter';

export interface ColumnSettings {
  width: number;
}

export async function generateExcel({ name, tabs }: ReportSettings): Promise<void> {
  const workbook = new Workbook();

  tabs.forEach(({ name: tabName, header, totals, table }: TabSettings) => {
    const worksheet = workbook.addWorksheet(tabName);
    const columnSettings: ColumnSettings[] = [];

    if (header?.length && totals?.length && table?.length) {
      // totals row preserves the original blank-row gap:
      // row 1: header, rows 2..N+1: data, row N+2: empty, row N+3: totals
      const totalsRowIndex = table.length + 3;

      // Render header (row 1)
      header.forEach((column, colIndex) => {
        worksheet.getCell(1, colIndex + 1).value = column;
        columnSettings[colIndex] = getColumnSettings(column, colIndex, columnSettings[colIndex]);
      });

      // Render table body (rows 2 to N+1)
      table.forEach((row: FormattedCell[], rowIndex: number) => {
        const excelRowIndex = rowIndex + 2;
        row.forEach((column, colIndex) => {
          const cellData = valueToCell(column);
          const cell = worksheet.getCell(excelRowIndex, colIndex + 1);
          cell.value = cellData.v;
          if (cellData.z) {
            cell.numFmt = cellData.z;
          }
          columnSettings[colIndex] = getColumnSettings(column.value, colIndex, columnSettings[colIndex]);
        });
      });

      // Render totals (row N+3)
      totals.forEach((column, colIndex) => {
        const cellData = valueToCell(column);
        const cell = worksheet.getCell(totalsRowIndex, colIndex + 1);
        cell.value = cellData.v;
        if (cellData.z) {
          cell.numFmt = cellData.z;
        }
      });

      // Set column widths
      columnSettings.forEach((settings, colIndex) => {
        if (settings?.width > 0) {
          worksheet.getColumn(colIndex + 1).width = settings.width;
        }
      });
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  saveAs(blob, name);
}

